import type { Organizer } from '@/types';
import styles from './AvatarComponent.module.scss';
import { CrownIcon } from '@/components/_shared/Icons';
import { UserIcon } from '../../UserIcon/UserIcon';
import { Avatar } from '@eventbrite/marmalade';
import { getImageProps } from 'next/image';

export interface AvatarComponentProps {
  organizer: Organizer;
  size?: 'small' | 'large';
}

export const AvatarComponent: React.FC<AvatarComponentProps> = ({ organizer, size = 'large' }) => {
  const avatarText = (organizer.name && organizer.name[0]) || '';

  const className = `${styles.avatarWithBadge} ${styles[size]}`.trim();

  const {
    props: { src },
  } = getImageProps({
    alt: '',
    width: 52,
    height: 58,
    src: organizer.image || '',
  });

  const isSuperOrganizer = organizer.superOrganizer === true;

  return (
    <div className={className}>
      <Avatar
        className={styles.customAvatar}
        text={avatarText}
        icon={<UserIcon />}
        imageSrc={src}
        imageAlt={organizer.name}
        placeholder={organizer.name}
      ></Avatar>
      {isSuperOrganizer && (
        <div className={styles.badge}>
          <CrownIcon />
        </div>
      )}
    </div>
  );
};
